import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { ThreadsActions } from '@store/reducers/threads'
import { InternalThreadsActions } from '@store/reducers/threads/actions'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'

export function* edit({ payload }: ReturnType<typeof ThreadsActions.edit>) {
  const projectId: ID = yield select(migrationProjectSelector.getProjectId)

  yield put(InternalThreadsActions.update(payload))

  yield call(API.Threads.updateContent, payload.uuid, projectId, payload)
}
